/**
 * The orb — the console's one loading indicator.
 *
 * A thin adapter over `thinking-orbs` (the package behind
 * orbs.jakubantalik.com, which the person picked as the house style).
 * The package ships nine hand-tuned states at exactly two tuned sizes —
 * 64 for chat-avatar scale, 20 for inline-text scale — so this wrapper
 * only wires our theme switch in and defaults the state.
 */

import { type ReactNode } from 'react';
import { ThinkingOrb, type OrbState } from 'thinking-orbs';

import { useStoreState } from '../store-context.js';

export function Orb({ size = 20, state = 'working' }: { size?: number; state?: OrbState }): ReactNode {
  const theme = useStoreState((store) => store.theme);
  // The package only ships presets at two sizes (64 and 20); any other value
  // makes its internal preset lookup return undefined and crash. Render at the
  // nearest supported preset and let CSS scale the canvas to the exact size.
  const preset: 64 | 20 = size >= 42 ? 64 : 20;
  return (
    <span className="orb">
      <ThinkingOrb
        state={state}
        size={preset}
        theme={theme === 'system' ? 'auto' : theme}
        style={{ width: size, height: size }}
      />
    </span>
  );
}
